import React, { useEffect } from "react";
import { useState } from "react";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { ConstructionOutlined } from "@mui/icons-material";
import { padding } from "@mui/system";
import { fn } from "moment/moment";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setsavebutton } from "../../../../redux/features/CampaignSlice";

export default function MappedAudio(
  props
  // , parentCallback
) {
  const [showchoose, setshowchoose] = useState(false);

  const Rdata = useSelector((data) => data);

  const dispatch = useDispatch();
  console.log("oioodddarray", Rdata);

  // const sendData = () => {
  //   parentCallback(showchoose);
  // };

  const handlechangeAudioF1 = async (e, filee) => {
    console.log("enter");
    const aud = e.target.files[0];
    console.log("enter", aud);
    var fileName = e.target.value;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "wav") {
      //   setOpen(true);
      //   setTimeout(() => {
      // setOpen(false);
      let koibhiarray = props?.audioArray;
      console.log("vfffiiilllee", props?.audioArray);
      koibhiarray?.push(aud);
      // console.log("vfffiiilllee", koibhiarray);
      props?.setaudioArray(koibhiarray);

      //   audioArray.push(aud);
      //   }, 500);
    }

    // else if (onVoiceChange == true) {
    //   toast.error("Only .Wav files are allowed!", {
    //     theme: "colored",
    //   });
    //   document.getElementById("fileName").value = "";
    // }
    else {
      toast.error("Only .Wav files are allowed!", {
        theme: "colored",
      });
      document.getElementById("fileName").value = "";
    }
  };
  const Edit = (e, value, index) => {
    // let valueee = false;
    dispatch(setsavebutton(false));
    var id = props?.data?.id;
    setshowchoose(true);
    console.log("hhhhhhii33oo7788", id);
    let idarray = props?.audioIDArray;
    idarray?.push(id);
    props?.setaudioIDArray(idarray);
  };

  // const fun1 = () => {
  //   props?.settrufalse(false);
  // };

  // React.useEffect(() => {
  //   fun1();
  // }, [Edit]);

  return (
    <>
      <div className="">
        {/* {showbrows == true ? ( */}

        {/* //   ) : ( */}
        <>
          {" "}
          {showchoose == true ? (
            <>
              <div className="col-md-6">
                <div class="  input-group m-0 mb-3" id="input_group_8">
                  <Button
                    //   disabled={Radiosdisabled.choose}
                    variant="contained"
                    component="label"
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    <input
                      // accept="application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet"
                      multiple
                      // required={RadioGroupValues == 4}
                      required
                      // value={getAudioF1.fileuplode}
                      id="fileName"
                      type="file"
                      style={{
                        color: "#7b809a",
                      }}
                      // onChange={(e) => {
                      //   setgetAudioF1({
                      //     ...getAudioF1,
                      //     fileuplode: e.target.files[0],
                      //   });
                      // }}
                      onChange={(e, filee) => {
                        handlechangeAudioF1(e, filee);
                      }}
                    />
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row w-100">
                <div className="col-md-12">
                  <label>File Name : {props?.data?.filename}</label>
                </div>
              </div>
              <div
                className="d-flex align-tems-center mx-0"
                style={{ alignItems: "center" }}
              >
                <audio
                  className="m-0 w-100"
                  controls
                  src={props?.data?.downlaodUrl}
                >
                  <a href={props?.data?.downlaodUrl}>Download audio</a>
                </audio>
                <DisabledByDefaultIcon
                  style={{
                    display: "flex",
                    justifyContant: "center",
                    alignItem: "center",
                    cursor: "pointer",
                  }}
                  onClick={(e) => Edit(e)}
                />
              </div>
            </>
          )}
        </>
      </div>
    </>
  );
}
